import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import RouterLink from '../react_router/RouterLink';
import { Redirect, useRouteMatch } from 'react-router-dom';
import RouterUtil from '../../utils/RouterUtil';
// import ErrorItem from './ErrorItem';
import FormControl from '../forms/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import LocalStorage from '../../local_storage/LocalStorage';
import AppCtx from '../../contexts/app_context';


const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function SignIn(props) {
  const classes = useStyles();
  const match = useRouteMatch()
  const agents = LocalStorage.get('users') || {}
  const { setCurrentUser } = React.useContext(AppCtx)
  const [agent_name, setAgentName] = React.useState('')
  const [redirect, setRedirect] = React.useState(null)
  const submit = async e => {
    e.preventDefault()
    // validate, display the error message one at a time
    // if (email === '') {
    //   setError('Your email is empty')
    // } else if (password === '') {
    //   setError('Your password is empty')
    // } else {
    //   if (error) {
    //     setError(error)
    //   } else {
    // yes! we passed all of the validations
    // reset
    // setEmail('')
    // setPassword('')
    // setError('')
    // if props.redirect has a value route to given path
    if (agent_name) {
      setCurrentUser(agent_name) // set current user if we have a string
      props.redirect_path
        && setRedirect(<Redirect to={props.redirect_path} />)
    }
    // }
    // }
  }
  if (redirect) {
    return redirect
  }

  return (
    <Container component="main" maxWidth="xs">
      <br/>
      <br/>
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign in
        </Typography>
        <form className={classes.form} onSubmit={submit}>
          <FormControl>
            <InputLabel id="demo-simple-select-helper-label">Agent Name</InputLabel>
            <Select
              labelId="demo-simple-select-helper-label"
              id="demo-simple-select-helper"
              value={agent_name}
              onChange={(e) => setAgentName(e.target.value)}
            >
              {Object.values(agents).map(({ agent_name }) => (
                <MenuItem value={agent_name} key={agent_name}>{agent_name}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              disabled={!agent_name}
            >
              Sign In
          </Button>
          </FormControl>
          {/* <ErrorItem error={error} /> */}
          <Grid container>
            <Grid item>
              <RouterLink styled_link route href={RouterUtil.parsePath(match.path).parent}>
                Don't have an account? Sign Up
              </RouterLink>
            </Grid>
          </Grid>
        </form>
      </div>

    </Container>
  );
}